import React, { memo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from 'moment';
import "react-day-picker/lib/style.css";
import "moment/locale/ja";

import { PopoverText } from '../../common/parts/PopoverText';

import { confirmState } from '../../../store/confirmState';
import { orderState } from '../../../store/orderState';

export const FormExamDate = memo((props) => {
  const isConfirm = useRecoilValue(confirmState);
  const [orderData, setOrderData] = useRecoilState(orderState);

  // 日付をYYYY-MM-DDの書式で返すメソッド
  const formatDate = (dt) => {
    const formatRules = [
      "YYYY-MM-DD", "YYYY/MM/DD", "YYYYMMDD",
    ]
    let formatedDate = moment(dt, formatRules).format('YYYY-MM-DD');
    return formatedDate;
  }

  const onChangeExamDt = (selectedDay, modifiers, dayPickerInput) => {
    const input = dayPickerInput.getInput();
    setOrderData({...orderData, examdt: formatDate(input.value)});
  }
  const onChangeExamTm = (e) => {
    setOrderData({...orderData, examdtime: e.target.value});
  }

  return (
    <>
      <p className="h3">受診予約日時 
        <PopoverText textTitle="受診希望日" textBody="ご予約したの受診日が〜〜〜。" />
      </p>
      <p className="text-danger">
        無断キャンセルや度重なる日程変更は、医療機関へご迷惑となりますのでお控えください。<br />
        健診のお受入れが難しくなってしまう場合もございますので、ご注意ください。
      </p>

      <div className="card mb-4">
        <div className="card-body">
          <div className="input-group">
            <DayPickerInput
              inputProps={{ 
                className: 'form-control',
                readOnly: !isConfirm,
                disabled: isConfirm,
              }}
              dayPickerProps={{
                localeUtils: MomentLocaleUtils,
                locale: "ja",
                disabledDays: [
                  {
                    before: new Date(),
                  },
                ]
              }}
              placeholder='日付を選択(必須)'
              onDayChange={onChangeExamDt}
              value={orderData.examdt}
            />
            <input className="form-control" type="time" value={orderData.examdtime} onChange={onChangeExamTm} disabled={isConfirm} />
          </div>
        </div>
      </div>

      <p className="text-center h1"><i className="fas fa-chevron-down"></i></p>
    </>
  );
});